import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * メッセージ送信にひもづく家族 API 操作クラス
 */
export default class SendMessageReadFamilies {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET SendMessageReadFamilies
   */
  public async get(userStore: LoginUser, datetime: number): Promise<Array<SendMessageReadFamilyModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      datetime: datetime
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SendMessageReadFamilies, formatParams);
    const response = await this.commonService.executeGet<Array<SendMessageReadFamilyModel>>(userStore, requestUrl, this.constructor.name, null, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

/**
 * メッセージ送信にひもづく家族
 */
export interface SendMessageReadFamilyModel {
  /** 部屋名 */
  residentRoomName: string;
  /** 利用者ID */
  residentId: number;
  /** 利用者名 */
  residentName: string;
  /** 家族名 */
  familyName: string;
  /** 役割 */
  familyPosition: string;
  /** 電話番号 */
  familyTel: string;
  /** 関係性 */
  familyRelation: string;
  /** 既読時間、未読の場合はundefinedが格納されている */
  readDatetime: number | undefined;
}
